import { clearAuthSession, getAccessToken, getStoredSessionUser } from "@/lib/auth";

const LOGIN_EXPIRED = "/login?session=expired";

let inFlight = false;

function isPublicPath(pathname) {
  const path = pathname || "";
  return path === "/login" || path.startsWith("/login") || path.startsWith("/hostel-check-in");
}

/**
 * Clears the staff OTP session and sends the user back to login.
 * Safe to call from timers, axios interceptors, and React effects.
 */
export function expireSession() {
  if (inFlight) return;
  const hadSession = Boolean(getAccessToken() || getStoredSessionUser());
  if (!hadSession) return;

  inFlight = true;
  clearAuthSession();

  const path = window.location.pathname || "";
  if (isPublicPath(path)) {
    inFlight = false;
    return;
  }

  window.location.assign(LOGIN_EXPIRED);
}

export function shouldIgnoreAuthFailure(config) {
  const url = `${config?.baseURL || ""}${config?.url || ""}`;
  return /\/otp\/(send|verify)/i.test(url);
}

export function attachSessionExpiryInterceptor(axiosInstance) {
  axiosInstance.interceptors.response.use(
    (res) => res,
    (error) => {
      const status = error?.response?.status;
      if (status === 401 && getAccessToken() && !shouldIgnoreAuthFailure(error?.config)) {
        expireSession();
      }
      return Promise.reject(error);
    }
  );
}
